import dayjs from "dayjs"

const unreportedWarningText = (day: string) => `${day}の清掃です！`

export const composeUnreportedWarning = (
    cleaningDate: string,
    now: dayjs.Dayjs = dayjs()
) => {
    const isSameDay = now.isSame(dayjs(cleaningDate), "day")
    if (isSameDay) return unreportedWarningText("本日")

    const dayDiff = dayjs(cleaningDate).diff(now, "day")

    /**
     * NOTE:
     * 前述のisSameDayがfalseになっても、24時間以内の差であればdayDiffは0になる
     * その場合は、実質的には「明日」であるので、警告は出さない。
     * そのため、等号付き不等号である>=で判定する。
     */
    if (dayDiff >= 0) {
        return undefined
    }
    return unreportedWarningText(`${-dayDiff}日前`)
}
